module.exports = __webpack_public_path__ + "media/customizations/cotavera/back-78e519939391b3f9f3e2f58eb075a85d.jpg";